<script>
    export let data;
    let checkFirstCharacter = '';
    let reverseArr = [];
    let splitArr;
    if(data) {
        checkFirstCharacter = data.charAt(0);
        if(checkFirstCharacter == '/') {
            data = data.substring(1);
        }
        splitArr = data.split("/")
        reverseArr = splitArr.reverse();
    }
</script>
<style>

</style>
{#each reverseArr as item, i}
    {#if item != ""}
        {#if i==0}
            <span style="font-weight: bold;">{item}</span> {reverseArr.length > 1 ? ' < ' : ''}
        {:else}
            {#if reverseArr.length > 3 }
                {item} {reverseArr.length - 1 != i ? ' < ': ''}
            {:else}
                {item} {reverseArr.length - 1 != i ? ' < ': ''}
            {/if}
        {/if}
    {/if}
{/each}

